import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { AppLocalizationService } from "../../../services/AppLocalizationService";

/**
 * Localization navigation service
 */
@Injectable({
  providedIn: 'root'
})
export class LocalizationNavigationService {

  /**
   * Checks is template selected in dictionary
   */
  _templateSelectedSubject = new BehaviorSubject<boolean>(false);

  /*
    Display save localization icon
  */
  _displaySaveIcon = new BehaviorSubject<boolean>(false);

  /*
  Grid item selected
  */
  _gridItemSelected = new BehaviorSubject<any>(null);

  /**
   *  Is translation label updated
   */
  _isTranslationUpdated = new BehaviorSubject<boolean>(false);

  /**
   * Save clicked Subject
   */
  private _saveClicked$ = new Subject<void>();

  /**
   * Save clicked Observable
   */
  saveClicked$ = this._saveClicked$.asObservable();

  /**
   * Display localization form add and edit icons
   */
  _displayAddEditIcons = new BehaviorSubject<boolean>(true);

  /**
   * Active localization
   */
  private activeLocalization: any;

  /**
   * Selected template
   */
  private selectedTemplate: any;

  /**
   * Constructor
   * @param appLocalization
   */
  constructor(private appLocalization: AppLocalizationService) { }

  /**
   * On display localization save icon
   * @param value Indicating whether to display the icon or not
   */
  displaySaveLocalizationIcon(value: boolean) {
    this._displaySaveIcon.next(value);
  }

  /**
   * On grid item selected
   * @param item
   */
  onGridItemSelected(item: any) {
    this._gridItemSelected.next(item);
  }

  /**
   * On is label (translation) updated
   * @param value Is translation updated value
   */
  onIsTranslationUpdated(value: boolean) {
    this._isTranslationUpdated.next(value);
  }

  /**
   * On is save clicked
   */
  onSaveClicked() {
    this._saveClicked$.next();
  }

  /**
   * Sets a value for is template in dictionary selected
   * @param value
   */
  onTemplateSelected(value) {
    this._templateSelectedSubject.next(value);
  }

  /**
   * On display localization add and edit icon
   * @param value Indicating whether to display the icons or not
   */
  displayAddEditIcons(value: boolean) {
    this._displayAddEditIcons.next(value);
  }

  /**
  * Set active localization
  * @param localization Active localization
  */
  setActiveLocalization(localization: any): void {
    this.activeLocalization = localization;
    if (localization?.locale) {
      this.appLocalization.setReportDesignerDictionaryConfigById(localization?.id);
    }
  }

  /**
  * Get active localization
  */
  getActiveLocalization(): any {
    return this.activeLocalization;
  }

  /**
  * Set active template
  * @param template Active template
  */
  setActiveTemplate(template: any): void {
    this.selectedTemplate = template;
  }

  /**
  * Get active template
  */
  getActiveTemplate(): any {
    return this.selectedTemplate;
  }
} 
